import MontageTeam from '@/models/MontageTeam';

/**
 * MontageTeamRepository - VuexORM queries for montage teams
 */
export default class MontageTeamRepository {
    /**
     * Get all montage teams
     */
    public static getAll(): MontageTeam[] {
        return MontageTeam.query().withAllRecursive().get();
    }

    /**
     * Get a single montage team by ID
     */
    public static getById(id: string): MontageTeam | null {
        if (!id) {
            return null;
        }
        return MontageTeam.query().withAllRecursive().whereId(id).first();
    }

    /**
     * Get montage teams by driver
     */
    public static getByDriver(driver: string): MontageTeam[] {
        return MontageTeam.query().withAllRecursive().where('driver', driver).get();
    }

    /**
     * Get montage teams by team leader
     */
    public static getByTeamLeader(teamLeader: string): MontageTeam[] {
        return MontageTeam.query().withAllRecursive().where('teamLeader', teamLeader).get();
    }

    /**
     * Get montage teams by name
     */
    public static getByName(name: string): MontageTeam[] {
        return MontageTeam.query().withAllRecursive().where('name', name).get();
    }
}
